// Components/Custom/BenefitsModal.tsx
import CustomButton from "Components/Custom/CustomButton";
import Icon, { IconName } from "Components/Icons/Icon";
import React from "react";
// import { useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

interface BenefitsModalProps {
  isOpen: boolean;
  onCancel: () => void;
  iconName?: IconName;
  title: string;
  description: string;
  buttonText: string;
  onButtonClick: () => void;
  bodyClassName?: string;
  cancelText?: string;
  isLoading?: boolean;
}

const RestrictedAccessModal: React.FC<BenefitsModalProps> = ({
  isOpen,
  onCancel,
  iconName,
  title,
  description,
  buttonText,
  onButtonClick,
  bodyClassName,
  cancelText,
  isLoading = false,
}) => {
  // const navigate = useNavigate();
  return (
    <Modal
      isOpen={isOpen}
      toggle={onCancel}
      centered
      size="md"
      backdrop="static"
      className="p-4 overflow-hidden"
      contentClassName="br-12"
    >
      <ModalHeader
        toggle={onCancel}
        className="bg-white pt-3 pe-4 ps-4 br-12"
      />

      {iconName && (
        <Icon name={iconName} fontSize={80} className="align-self-center" />
      )}

      <ModalBody
        className={`pt-4 pb-0 ${
          bodyClassName ?? "align-content-center text-center"
        }`}
      >
        <h1 className="text-black2D fs-24 fw-semibold font-primary mt-1">
          {title}
        </h1>
        <div className="text-grey89 fs-14 fw-normal font-primary">
          {description
            .split("\n\n")
            .map((para) => para.trim())
            .filter(Boolean)
            .map((para, i) => (
              <p key={i} className="mb-2">
                {para}
              </p>
            ))}
        </div>
      </ModalBody>
      <ModalFooter className="p-3 justify-content-start">
        <CustomButton
          text={buttonText}
          className="bg-primary br-7 w-100 mx-3 mb-2"
          textClassName="text-white"
          onClick={onButtonClick}
          loading={isLoading}
        />
        {cancelText && (
          <CustomButton
            text={cancelText}
            newClassName="mb-2 bg-transparent border-0 w-100 justify-content-center mt-n2"
            textClassName="text-redD2 text-center fs-16 fw-normal font-primary"
            onClick={onCancel}
          />
        )}
      </ModalFooter>
    </Modal>
  );
};

export default React.memo(RestrictedAccessModal);
